import type { FeatureFlagValues } from '@his/feature-flags';
import { createContext, useContext } from 'react';

type FeatureFlagsContextValue = { flags: FeatureFlagValues };

export const FeatureFlagsContext = createContext<
  FeatureFlagsContextValue | undefined
>(undefined);

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within FeatureFlagProvider');
  }

  return context;
};
